//@ts-check
import entityModule from '@/common/lib/entity-module';
import { appInit } from './app.action';
const initState = {
  key: null,
  status: 0,
  startMain: false,
  startSub: false,
  date: '',
  msgText: '',
  pcCheckError: 0,
};

export default (state = initState, action) => {
  const payload = action.payload;
  switch (action.type) {
    case String(appInit):
      return {
        ...state,  
        key: payload.key,
      };
    case '@@vp/START_MAIN':
      return {
        ...state,
        startMain: true
      };
    case '@@vp/START_SUB':
      return {
        ...state,
        startSub: true
      };
    case '@@vp/PC_CHECK_ERROR':
      return {
        ...state,
        pcCheckError: 1,
      };
    default:
      return entityModule(state, action);
  }
};